<template>
    <div class="container" style="height: 100%">
        <div class="row flex-grow-0">
            <div class="col-md-4">
                <label for="commonCode">
                    <span>{{ $t("공통코드 값") }}</span>
                    <i class="material-icons ml-1" :style="{ fontSize: '0.8rem' }">check_circle</i>
                </label>
                <valid-input
                    :vid="'공통코드'"
                    :classList="'form-control'"
                    :inputType="'text'"
                    :inputValue.sync="detailInfo.commonCode"
                    :placeholder="$t('공통코드')"
                    :rules="rules.COMMON_CODE_PUBLIC_RULE"
                    :errorMessage="validMessage.COMMON_CODE_PUBLIC_VALID_MESSAGE"
                    :disabled="!isNewMode"
                ></valid-input>
            </div>
            <div class="col-md-3">
                <label for="codeName">
                    <span>{{ $t("공통코드 명") }}</span>
                    <i class="material-icons ml-1" :style="{ fontSize: '0.8rem' }">check_circle</i>
                </label>

                <valid-input
                    :vid="'공통코드 명'"
                    :classList="'form-control'"
                    :inputType="'text'"
                    :inputValue.sync="detailInfo.codeName"
                    :placeholder="$t('공통코드 명')"
                    :rules="rules.COMMON_NAME_RULE"
                    :errorMessage="validMessage.COMMON_NAME_VALID_MESSAGE"
                    :disabled="!isEditMode"
                ></valid-input>
            </div>
            <div class="col-md-3">
                <label for="codeCategory">
                    <span>{{ $t("카테고리") }}</span>
                    <!-- <i class="material-icons ml-1" :style="{ fontSize: '0.8rem' }">check_circle</i> -->
                </label>
                <div class="selectCategory">
                    <input
                        v-model="detailInfo.codeCategory"
                        type="text"
                        :disabled="!isEditMode"
                        class="form-control"
                        id="codeCategory"
                        placeholder="카테고리 입력"
                    />
                    <div class="input-group-append">
                        <button
                            :disabled="!isEditMode"
                            class="btn btn-secondary btn-sm"
                            type="button"
                            style="width: 100%;"
                            @click="openCategoryModal"
                        >
                            선택
                        </button>
                    </div>
                    <!-- <valid-input
                        :vid="'카테고리'"
                        :classList="'form-control'"
                        :inputType="'text'"
                        :inputValue.sync="detailInfo.codeCategory"
                        :placeholder="$t('카테고리')"
                        :rules="rules.COMMON_CODE_PUBLIC_RULE"
                        :errorMessage="validMessage.COMMON_CODE_PUBLIC_VALID_MESSAGE"
                        :disabled="!isEditMode"
                    ></valid-input>
                    -->
                </div>
            </div>
            <div class="col-md-2">
                <label for="enabled">
                    <span>{{ $t("사용여부") }}</span>
                    <!-- <i class="material-icons ml-1" :style="{ fontSize: '0.8rem' }">check_circle</i> -->
                </label>
                <select v-model="detailInfo.enabled" :disabled="!isEditMode" id="enabled" class="form-control">
                    <option value="">선택</option>
                    <option v-for="code in $store.state.commonCodes.enabled" :key="code.value" :value="code.value">
                        {{ code.text }}
                    </option>
                </select>
            </div>
        </div>

        <div style="display: flex; flex: 1; width: 100%; margin-bottom: 16px;">
            <div style="flex: 1; padding: 0px 10px 0px 0px;">
                <label for="etcInfo1">
                    <span>{{ $t("추가 속성1") }}</span>
                </label>
                <input
                    type="text"
                    class="form-control"
                    v-model="detailInfo.etcInfo1"
                    id="etcInfo1"
                    placeholder="추가 속성1"
                    :disabled="!isEditMode"
                />
                <!-- <valid-input
                    :vid="'속성 라벨1'"
                    :classList="'form-control'"
                    :inputType="'text'"
                    :inputValue.sync="detailInfo.etcInfo1"
                    :placeholder="$t('속성 라벨1')"
                    :notRules="true"
                    :NonStatus="true"
                    :rules="rules.COMMON_NAME_RULE"
                    :disabled="!isEditMode"
                ></valid-input> -->
            </div>
            <div style="flex: 1; padding: 0px 10px 0px 10px;">
                <label for="etcInfo2">
                    <span>{{ $t("추가 속성2") }}</span>
                </label>
                <input
                    type="text"
                    class="form-control"
                    v-model="detailInfo.etcInfo2"
                    id="etcInfo2"
                    placeholder="추가 속성2"
                    :disabled="!isEditMode"
                />
            </div>
            <div style="flex: 1; padding: 0px 10px 0px 10px;">
                <label for="etcInfo3">
                    <span>{{ $t("추가 속성3") }}</span>
                </label>
                <input
                    type="text"
                    class="form-control"
                    v-model="detailInfo.etcInfo3"
                    id="etcInfo3"
                    placeholder="추가 속성3"
                    :disabled="!isEditMode"
                />
            </div>
            <div style="flex: 1; padding: 0px 10px 0px 10px;">
                <label for="etcInfo4">
                    <span>{{ $t("추가 속성4") }}</span>
                </label>
                <input
                    type="text"
                    class="form-control"
                    v-model="detailInfo.etcInfo4"
                    id="etcInfo4"
                    placeholder="추가 속성4"
                    :disabled="!isEditMode"
                />
            </div>
            <div style="flex: 1; padding: 0px 0px 0px 10px;">
                <label for="etcInfo5">
                    <span>{{ $t("추가 속성5") }}</span>
                </label>
                <input
                    type="text"
                    class="form-control"
                    v-model="detailInfo.etcInfo5"
                    id="etcInfo5"
                    placeholder="추가 속성5"
                    :disabled="!isEditMode"
                />
            </div>
        </div>

        <div class="row flex-grow-0" style="margin-bottom: 0px !important;">
            <div class="col-md-1" style="text-align: center">
                <label for="equipDesc">설명</label>
            </div>
            <div class="col-md-11">
                <!-- <textarea v-model="detailInfo.desc" type="text" class="form-control" id="equipDesc"
                    :disabled="!isEditMode" style="resize: none; overflow-y: auto;" rows="3"></textarea> -->
                <valid-textarea
                    :inputType="'text'"
                    :inputValue.sync="detailInfo.desc"
                    :NonStatus="true"
                    :rows="3"
                    :classList="'desc-ctn form-control'"
                    :rules="rules.COMMON_DESC_RULE"
                    :disabled="!isEditMode"
                >
                </valid-textarea>
            </div>
        </div>

        <div style="height: 55%;">
            <!-- TableList -->
            <TableListComponent
                ref="TableListComponent"
                :title="'상세코드 목록'"
                :columns="columns"
                :rows="detailInfo.codeItems"
                :keyField="'codeItem'"
                :transCodes="transCodes"
                :controls="controls"
                :mode="mode"
                :useMaxHeight="true"
                :toggleFields="['enabled']"
                @button-click="handleListButtonClick"
                :useFilter="false"
                @row-click="handleListItemClick"
                @toggle-changed="handleItemToggle"
            />
        </div>

        <!-- Detail PropUp -->
        <div class="row flex-grow-0">
            <!-- InPropDetail Popup -->
            <b-modal ref="CodeItemDetailModal" size="md" centered @hidden="closeCodeItemModal">
                <template #modal-header>
                    <h5>
                        {{ tempCodeItemIndex !== null || undefined ? "상세코드 편집" : "상세코드 추가" }}
                    </h5>
                </template>
                <template #modal-footer>
                    <button
                        v-show="isEditMode"
                        type="button"
                        class="btn btn-primary"
                        @click="handleAddListItem"
                        style="flex: 1"
                    >
                        저장
                    </button>
                    <button type="button" class="btn btn-secondary" @click="closeCodeItemModal" style="flex: 1">
                        닫기
                    </button>
                </template>

                <CodeItemDetailPanel ref="CodeItemDetailPanel" :isEditMode="isEditMode" :data="detailInfo" />
            </b-modal>
        </div>
        <b-modal ref="CategoryModal" hide-footer title="카테고리 선택">
            <b-form-radio-group
                v-model="selectedCategory"
                :options="this.codeCategoryArr"
                stacked
                class="commonCodeCategoryRadio"
            />
            <div class="mt-3 d-flex justify-content-end">
                <b-button variant="primary" @click="applySelectedCategory">선택</b-button>
                <b-button variant="secondary" class="ml-2" @click="closeCategoryModal">닫기</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import * as rules from "@src/consts/ruleConsts.js";
import * as validMessage from "@src/consts/validMessageConsts.js";
// import backEndApi from "@src/api/backEndApi";

import TableListComponent from "@views/component/v2.1/ListDetailView/TableList.vue";
import CodeItemDetailPanel from "./CodeItemDetailPanel.vue";
import * as popupMessages from "@src/consts/popupMessageConsts";

export default {
    components: {
        TableListComponent,
        CodeItemDetailPanel,
    },
    props: ["detailInfo", "mode", "codeCategoryArr"],
    data() {
        return {
            selectedCategory: null,

            controls: [
                { event: "delete", label: "-", class: "btn-danger" },
                { event: "regist", label: "+", class: "btn-warning" },
            ],
            transCodes: [
                {
                    field: "enabled",
                    codes: this.$store.state.commonCodes.enabled,
                },
            ],
            columns: [
                // Detail 테이블 column
                {
                    label: this.$t("상세코드 값"),
                    field: "codeItem",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center font-weight-bold text-dark",
                    // compositionFields: ['codeItem', 'codeName']
                },
                {
                    label: this.$t("상세코드 명"),
                    field: "codeName",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center font-weight-bold  text-dark",
                    // compositionFields: ['codeItem', 'codeName']
                },
                {
                    label: this.$t("속성1"),
                    field: "etcInfo1",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: this.$t("속성2"),
                    field: "etcInfo2",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: this.$t("속성3"),
                    field: "etcInfo3",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: this.$t("속성4"),
                    field: "etcInfo4",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: this.$t("속성5"),
                    field: "etcInfo5",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: this.$t("사용 여부"),
                    field: "enabled",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center",
                    width: "80px",
                },
            ],
            tempCodeItemIndex: null,
            rules,
            validMessage,
            popupMessages,
        };
    },
    async created() {},
    mounted() {
        // this.setDetailVgtHeader();
    },
    computed: {
        isEditMode() {
            return this.mode !== "view";
        },
        isNewMode() {
            return this.mode === "new";
        },
    },
    watch: {
        detailInfo() {
            this.setDetailVgtHeader();
        },
    },
    methods: {
        openCategoryModal() {
            this.selectedCategory = this.detailInfo.codeCategory || null;
            this.$refs.CategoryModal.show();
        },
        applySelectedCategory() {
            this.detailInfo.codeCategory = this.selectedCategory;
            this.$refs.CategoryModal.hide();
        },
        closeCategoryModal() {
            this.$refs.CategoryModal.hide();
        },
        async handleListButtonClick(event, options) {
            const that = this;

            switch (event) {
                case "regist":
                    await that.registNew();
                    break;

                case "delete":
                    await that.deleteChecked();
                    break;

                default:
                    console.warn("Unhandled Component Event. event:", event, "options:", options);
                    break;
            }
        },
        async handleListItemClick(row, index, toggle, check) {
            const that = this;
            if (toggle || check) return;
            that.tempCodeItemIndex = index;
            const findCodeItem = this.detailInfo.codeItems.find((item) => item.codeItem == row.codeItem);
            await that.$refs.CodeItemDetailModal.show();
            await that.$refs.CodeItemDetailPanel.setData(findCodeItem);
        },
        closeCodeItemModal() {
            const that = this;
            if (that.tempCodeItemIndex !== null || undefined) that.tempCodeItemIndex = null;
            that.$refs.CodeItemDetailModal.hide();
        },
        async deleteChecked() {
            const that = this;

            try {
                const checked = this.$refs["TableListComponent"].getCheckedRows();

                if (!that.isEmpty(checked)) {
                    const confirm = await this.alertConfirmWarning(popupMessages.COMMON_DELETE_CONFIRM_POPUP_MESSAGE);
                    if (!confirm.value) return;
                    checked.forEach(async () => {
                        // detailInfo에서 checked 항목을 제외.
                        that.detailInfo.codeItems = that.detailInfo.codeItems.filter((item) => {
                            return !checked.find((checkedProp) => checkedProp.codeItem === item.codeItem);
                        });
                    });
                    // await this.getDataList();
                } else {
                    this.alertNoti(popupMessages.COMMON_DELETE_NOTI_POPUP_MESSAGE);
                }
            } catch (e) {
                this.alertNoti(popupMessages.COMMON_REMOVE_ERROR_POPUP_MESSAGE);
                console.error(e);
            }
        },
        async registNew() {
            const that = this;

            await that.$refs.CodeItemDetailModal.show();
            await that.$refs.CodeItemDetailPanel.setData(null);
        },
        handleAddListItem() {
            const codeItem = this.$refs.CodeItemDetailPanel.getData();

            if (codeItem) {
                if (this.tempCodeItemIndex !== null || undefined) {
                    this.$set(this.detailInfo.codeItems, this.tempCodeItemIndex, codeItem);
                } else {
                    let check = this.detailInfo.codeItems.find(
                        (item) => item.codeItem === codeItem.codeItem || item.codeName === codeItem.codeName
                    );
                    if (check) {
                        // TODO: Alert Message
                        console.error("TODO: Alert Message");
                        console.error(
                            `In Property is already exists in codeItems. codeItem:${codeItem.codeItem}, codeName:${codeItem.codeName}`
                        );
                    } else {
                        this.$set(this.detailInfo.codeItems, this.detailInfo.codeItems.length, codeItem);
                    }
                }
            }

            this.$refs.CodeItemDetailModal.hide();
        },
        handleItemToggle(key, field, status) {
            const that = this;
            const found = that.detailInfo.codeItems.find((item) => item.codeItem === key);
            found.enabled = status;
        },
        setDetailVgtHeader() {
            if (this.detailInfo) {
                this.columns.map((item) => {
                    let key, index;

                    const token = "etcInfo";
                    if (item.field.includes(token)) {
                        key = item.field;
                        index = key.substring(token.length);
                        this.$set(item, "label", this.detailInfo[key] ? this.detailInfo[key] : `속성${index}`);
                    }
                });
            }
        },
    },
};
</script>

<style scoped>
.row {
    margin-bottom: 16px;
}

/* .col {
    position: relative;
    width: 100%;
    padding-right: 4px;
    padding-left: 4px;
} */
#codeCategory {
    width: 70%;
}
.input-group-append {
    width: 30%;
    font-size: small;
}
.selectCategory {
    display: flex;
}
</style>
